import React, { useEffect, useCallback } from "react";
import * as Sentry from "@sentry/react";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import {
  useGlobalEvents,
  isUserAuthenticated,
} from "helpers";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import "./theme/Colors.css";
import { getLicensePermissions, getUserProfile } from "./services";
import {
  updateSideNavOpen,
} from "./reducers/dashboard";
import "./App.css";
import "./index.css";
import "./common.css";

import "@pages/auth/index.css";
import { router as ShRouter } from "./routes/routes";

const App = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth?.isLoggedIn);
  useGlobalEvents();
  const isCurriculum = window.location.pathname.includes("curriculum");

  const handleCloseSidebar = useCallback(() => {
   dispatch(updateSideNavOpen(false));
  }, [dispatch]);

  useEffect(() => {
  const handleGlobalClick = (event) => {
    const sideNav = document.querySelector(".sideNav");

    if (sideNav && sideNav.contains(event.target)) return;

    handleCloseSidebar();
  };

  document.addEventListener("click", handleGlobalClick);

  return () => {
    document.removeEventListener("click", handleGlobalClick);
  };
}, [handleCloseSidebar]);


  useEffect(() => {
  if (isAuthenticated) {
    isUserAuthenticated();
  }
}, [isAuthenticated]);

  useEffect(() => {
  if (isAuthenticated && !isCurriculum) {
    dispatch(getLicensePermissions());
    dispatch(getUserProfile());
  }
}, [dispatch, isAuthenticated, isCurriculum]);

  useEffect(() => {
    setTimeout(() => {
      const color = window.location.href?.includes("curriculum")
        ? "#1471b0"
        : "#c60970";
      document.documentElement.style.setProperty("--primary-color", color);
      document.documentElement.style.setProperty("--bg-primary-color", color);
    }, 100);
  }, []);

  return (
    <React.Fragment>
      <RouterProvider router={ShRouter} />
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={"colored"}
      />
    </React.Fragment>
  );
};

export default Sentry.withProfiler(App);
